import cartRoutes from 'cart/routes';
import locationRoutes from 'locations/routes';
import menuRoutes from 'menus/routes';

const routes = [...cartRoutes, ...locationRoutes, ...menuRoutes];

export default routes;
